import { useEffect, useState } from "react";

/**
 * A simple helper to keep track of an error as a state variable. This is purely visual and doesn't have
 * anything to do with react hook form's submission validation
 */
export function useUncontrolledError<T>(validate: (_: T) => boolean | undefined, value: T) {
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!validate) {
      return;
    }
    if (validate(value)) {
      setError(false);
    } else {
      setError(true);
    }
  }, [value]);

  return error;
}
